/**
 * Display names for health device brands.
 *
 * `Observation.device.display` is written by the backend as the Terra provider
 * slug, lowercased. Terra serves its provider list from its API rather than a
 * fixed enum, so this map only holds the slugs that `capitalize` gets wrong.
 * Anything missing falls through to the fallback in `@utils/device-brand`,
 * which is correct for the single-word providers (garmin, whoop, fitbit).
 *
 * Only providers we have enabled are listed. Add an entry when enabling a
 * provider whose name is more than one word, taking the slug from the
 * `integration` field on `listTerraConnections` rather than guessing it.
 */
export const DEVICE_BRAND_NAME_OVERRIDES: Record<string, string> = {
  apple: 'Apple Health',
  freestylelibre: 'Freestyle Libre',
  omronus: 'Omron US',
};

/**
 * Product names required wherever a user connects a provider.
 *
 * Keyed by `TerraIntegration.integration`. Garmin's brand guidelines require
 * the full "Garmin Connect™" product name on any surface where a user
 * connects, and forbid abbreviating or restyling it, so it cannot be left to
 * the name Terra returns ("Garmin").
 *
 * This applies to connect surfaces only. Data attribution elsewhere uses the
 * brand name, so a reading sourced from Garmin reads "Garmin".
 */
export const CONNECT_APP_NAMES: Record<string, string> = {
  GARMIN: 'Garmin Connect™',
};
